import OnlineRentalDetails from './online-rental-details';

export default OnlineRentalDetails;
